import { Component } from "@angular/core";
import { CustomerAcessService } from "../crud-service";
import { CustomerAcessCrudIndex } from "./crud-index";
import { TypeComponentFieldEnum } from "src/app/domain/registration/enums/type-component-dynamic.enum";
import { IFieldConfig } from "src/app/domain/IFieldConfig";
import { SystemTypeEnum, SystemTypeIdEnum } from "src/app/domain/registration/enums/system-type.enum";
import { FormGroup, Validators } from "@angular/forms";
import { take } from "rxjs";

@Component({
  selector: 'app-customer-acess-index',
  templateUrl: './crud-index.component.html',
  styleUrls: ['./crud-index.component.sass']
})
export class CustomerAcessIndexComponent extends CustomerAcessCrudIndex {
  
  ngOnInit(): void {}

  override filterFields: IFieldConfig[] = [
    {
      type: TypeComponentFieldEnum.SELECT_CRUD,
      label: 'CLIENTE',
      name: 'customerId',
      value: '',
      componentData: {
        service: 'customer',
        filterName: 'name',
        multiple: false
      }
    },
    
    {
      type: TypeComponentFieldEnum.INPUT,
      label: 'TITULO',
      name: 'email',
      value: '',
    },
    {
      type: TypeComponentFieldEnum.SELECT,
      label: 'TIPO',
      name: 'type',
      options: Object.values(SystemTypeEnum),
      placeholder: 'Selecione uma opção',
      validation: [Validators.required],
    },
  ];

  override submitAdvancedFilter(filterForm: FormGroup) {
    let _filterForm = this.getFilters(filterForm.value);
    console.log('Parâmetros do filtro enviados:', _filterForm); 

    this.service
      .findByFilter(_filterForm, this.params)
      .pipe(take(1))
      .subscribe((dataWithPagination: any) => {
        let data = dataWithPagination[0];
        this.length = dataWithPagination[1];

        this.dataSource = this.getDataSource(data);
      });
  }

  private getFilters(filter: any) {
    let params: any = {};

    if (filter.email) params.email = filter.email.trim().toUpperCase();
    if (filter.customerId?.id) params.customerId = filter.customerId.id;
    if (filter.type) {
      params.type = this.mapTypeToBackendValue(filter.type);
    }

    console.log('Parâmetros do filtro:', params); 
    return params;
  }

  private mapTypeToBackendValue(type: SystemTypeEnum): string | undefined {
    switch (type) {
      case SystemTypeEnum.APPLICATION:
        return SystemTypeIdEnum[SystemTypeEnum.APPLICATION] as unknown as string;
      case SystemTypeEnum.SYSTEM:
        return SystemTypeIdEnum[SystemTypeEnum.SYSTEM] as unknown as string;
      default:
        return undefined;
    }
  }

  private mapBackendDataToDisplay(item: any): any {
    if (item.type) {
      if (item.type === SystemTypeIdEnum[SystemTypeEnum.APPLICATION]) {
        item.type = SystemTypeEnum.APPLICATION;
      } else if (item.type === SystemTypeIdEnum[SystemTypeEnum.SYSTEM]) {
        item.type = SystemTypeEnum.SYSTEM;
      }
    }

    if (item.createdAt) {
      item.createdAt = this.formatDate(item.createdAt);
    }

    return item;
  }

  private formatDate(dateString: string): string {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); 
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }


}
